// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dia_content[data-v-927d0f3e] {\n  display: block;\n}\n.dia_footer[data-v-927d0f3e] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
